import { render, staticRenderFns } from "./AssetCompressionData.vue?vue&type=template&id=47d45c94&lang=pug&"
import script from "./AssetCompressionData.vue?vue&type=script&lang=js&"
export * from "./AssetCompressionData.vue?vue&type=script&lang=js&"
import style0 from "./AssetCompressionData.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports